<ion-header [hidden]="scanCamera">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      Overboeking
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [hidden]="scanCamera">
  <ion-card>
    <ion-item>
      Van:
      <input
          placeholder="Project nummer"
          class="inputField"
          onclick="this.select()"
          (input)='onChangeProj("VAN", $any($event.target).value)'
          [(ngModel)]="inpProjVan"
      >
      <ion-button (click)="doScanProj('VAN')" [hidden]="global.optHideScanBtn">
          <ion-icon name="barcode"></ion-icon>
      </ion-button>
    </ion-item>
    <ion-item *ngIf="projlistVan.length">
      <ion-list style="max-height: 300px; overflow-y: scroll; width: 100%;">
        <ion-item *ngFor="let proj of projlistVan" >
          <ion-label (click)="click_proj('VAN', proj.nr)">{{ proj.des }}</ion-label>
        </ion-item>
      </ion-list>
    </ion-item>
    <ion-item *ngIf="!projlistVan.length">{{projShowVan.descr}}</ion-item>
  </ion-card>

  <ion-card>
    <ion-item>
      Naar:
      <input
          placeholder="Project nummer"
          class="inputField"
          onclick="this.select()"
          (input)='onChangeProj("NR", $any($event.target).value)'
          [(ngModel)]="inpProjNr"
      >
      <ion-button (click)="doScanProj('NR')" [hidden]="global.optHideScanBtn">
          <ion-icon name="barcode"></ion-icon>
      </ion-button>
    </ion-item>
    <ion-item *ngIf="projlistNr.length">
      <ion-list style="max-height: 300px; overflow-y: scroll; width: 100%;">
        <ion-item *ngFor="let proj of projlistNr" >
          <ion-label (click)="click_proj('NR', proj.nr)">{{ proj.des }}</ion-label>
        </ion-item>
      </ion-list>
    </ion-item>
    <ion-item *ngIf="!projlistNr.length">{{projShowNr.descr}}</ion-item>
  </ion-card>

  <ion-card>
    <ion-item>
      <input
          placeholder="Artikel nummer"
          class="inputField"
          onclick="this.select()"
          (input)='onChangeArt($any($event.target).value)'
          [(ngModel)]="inpArtnr"
          #inputArtnr
      >
      <ion-button (click)="doScanArt()" [hidden]="global.optHideScanBtn">
          <ion-icon name="barcode"></ion-icon>
      </ion-button>
    </ion-item>
    <ion-item *ngIf="artlist.length">
      <ion-list style="max-height: 300px; overflow-y: scroll; width: 100%;">
        <ion-item *ngFor="let art of artlist">
          <ion-label (click)="click_art(art.nr)">{{ art.des }}</ion-label>
        </ion-item>
      </ion-list>
    </ion-item>
    <ion-item *ngIf="!artlist.length">
      <ion-thumbnail slot='end' [hidden]="!artShow.metFoto">
        <ion-img [src]='artShow.imgUrl' (click)="viewerOpen=true"></ion-img>
      </ion-thumbnail>
      <ion-button expand="block" [routerLink]="['/home']" [disabled]="!validArt"><ion-icon name="attach"></ion-icon></ion-button>
      {{artShow.descr}}
    </ion-item>
  </ion-card>

  <ion-card>
    <ion-item>
      Aantal:
      <input type='number' placeholder="Aantal"
        class="inputField"
        [(ngModel)]="inpQty"
      > {{artShow.eenh}}
    </ion-item>
    <ion-button (click)="doOverboek()">
      Overboeken
    </ion-button>
  </ion-card>

</ion-content>
<app-imageview [open]="viewerOpen" [idx]="0" [imgs]="imgs" [ordnr]="" [currSub]="" (close)="viewerOpen = false;"></app-imageview>
